module.exports = __webpack_public_path__ + "assets/icon-fav-star-deselected.70cb2af2.svg";